import request from "./request";

const LoginService = {
    Login: async (body, signal) => {
        return await request.sendAuthRequest(`/token`, body, signal);
    },
    AcceptTerms: async (id, signal) => {
        return await request.sendUnAuthPostRequest(`/token/accept/${id}`, signal);
    },
    ResetPassword: async (model, context, signal) => {
        return await request.sendPostRequest(`/user/resetpassword`, model, context, signal);
    },
    ChangePassword: async (model, context, signal) => {
        return await request.sendPostRequest(`/user/changepassword`, model, context, signal);
    },
    SetPassword: async (model, signal) => {
        return await request.sendUnAuthPostRequest(`/user/setpassword`, model, signal);
    },
    Check: async (context, signal) => {
        return await request.sendRequest(`/token/check`, context.token, signal);
    },
    GetQuestions: async (code, signal) => {
        return await request.sendUnAuthPostRequest(`/user/resetmfaq`, code, signal);
    },
    ValidateSQ: async (code, model) => {
        return await request.sendUnAuthPostRequest(`/user/validateresetsq`, { code, Answers: model });
    },
};

export default LoginService;
